(function () {
  'use strict';

  var identityProviderUrls = {
    "saml": "/organizations/{orgId}/saml/request",
    "google": "/organization/{orgId}/google/redirect",
    "ipaas": "/organizations/{orgId}/ipaas/redirect"
  };
  angular.module('wsLrs.controllers').
  /**
   * Top level controller for "outside" page, everything which is unauthenticated,
   * currently separated from the core app
   */
  controller('OutsideCtrl', ['$scope', '$window', 'User', '$cookies', 'Config', 'Utils', '$http', 'OrganizationContext', '$location', function OutsideCtrl($scope, $window, User, $cookies, Config, Utils, $http, OrganizationContext, $location) {
    /*jshint camelcase: false */

    $scope.lightBackground = $location.$$path.includes('automated-emails');
    var allowableEmbedOrigins = ['http://localhost', 'https://watershedlrs.com'];
    var isClearToEmbed = allowableEmbedOrigins.includes($window.self.location.origin) && allowableEmbedOrigins.includes($window.top.location.origin);

    // Prevent clickjacking for un-allowed access to outside.html
    // Allowed access includes the marketing site for access to sign-up forms
    // see https://www.owasp.org/index.php/Clickjacking_Defense_Cheat_Sheet
    if ($window.self === $window.top || isClearToEmbed) {
      var antiClickjack = $window.document.getElementById("ws-anti-cj");
      antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
      $window.top.location = $window.self.location;
    }
    var wsConfig = Config.get();

    // If SSL is enabled, use it
    if (wsConfig.sslEnabled === true && $window.location.protocol !== "https:") {
      $window.location.protocol = "https";
      return;
    }

    // If an auto login is being attempted, make sure to clear out any existing user
    if ($window.location.hash.indexOf("signin?auto=true") >= 0) {
      User.clear();
    }

    // Is there already a user session?
    var user = User.get();
    $scope.authenticated = !user.unauthenticated;

    // If we hit the sign-on page with SSO, don't rely on our local cookie -- instead force
    // a handshake to renew the login and comfirm the user is still valid in identity provider.
    if (user.isSingleSignOn) {
      User.clear();
      OrganizationContext.clear();
      $cookies.remove("wsAuth");
      $cookies.remove("wsXSRFToken");
      $scope.authenticated = false;
    }

    // Are we in the middle of an OAuth authorization?
    var oauthAuthorizeUrl = $cookies.get('oauth_authorize_url');
    $scope.isOAuthAuthorize = typeof oauthAuthorizeUrl !== "undefined";

    // Are we accessing Watershed in the context of a particular organization?
    // Capture it if so...
    $scope.orgContext = null;
    OrganizationContext.load().then(function (orgContext) {
      $scope.orgContext = orgContext;
      return orgContext;
    });

    // Central logic for sending the user from outside to inside
    $scope.sendToApp = function sendToApp() {
      var destination = wsConfig.indexUrl;
      if ($scope.isOAuthAuthorize === true) {
        destination = oauthAuthorizeUrl;
        $cookies.remove('oauth_authorize_url');
      }
      $window.location.href = destination;
    };

    // If user already authenticated, send them to the app
    var redirect = $location.search().redirect;
    if ($scope.authenticated && (redirect === undefined || redirect !== "false")) {
      $scope.sendToApp();
      return;
    }

    // Centralized login functionality
    $scope.tryLogin = function tryLogin(username, password) {
      return $scope.tryLoginWithAuth("Basic " + Utils.base64encode(username + ":" + password));
    };
    $scope.tryLoginWithAuth = function tryLoginWithAuth(authHeader, xsrfToken) {
      var requestConfig = {
        headers: {
          "Authorization": authHeader
        }
      };
      if (xsrfToken) {
        requestConfig.headers['X-Requested-By'] = xsrfToken;
      }
      User.clear();
      return $http.post(wsConfig.apiUrl + "/login", null, requestConfig).then(function loginSuccess(response) {
        var data = response.data;

        // Currently, anyone using bearer token authentication is
        // identified by some external system. Mark that info here.
        data.isExternallyIdentified = authHeader.indexOf("Bearer") === 0;

        // Set up the new user session and send them to the app
        User.set(data);
        $scope.sendToApp();
        return data;
      });
    };
    $scope.getExternalLoginUrl = function getExternalLoginUrl(idProvider, orgId, returnUrl) {
      returnUrl = returnUrl || $window.location.href;
      var initiateUrl = identityProviderUrls[idProvider];
      if (initiateUrl) {
        initiateUrl = initiateUrl.replace("{orgId}", orgId);
        initiateUrl = initiateUrl + "?returnUrl=" + encodeURIComponent(returnUrl);
        return wsConfig.apiUrl + initiateUrl;
      }
    };
    $scope.googleLogin = function googleLogin() {
      $window.location.href = $scope.getExternalLoginUrl("google") + ($scope.orgContext !== null ? "&orgId=" + $scope.orgContext.id : "");
    };
  }]);
})();
